// extracted by mini-css-extract-plugin
export default {"CountdownContainer":"CountDown_CountdownContainer__IhaQG","TimerValue":"CountDown_TimerValue__HGhq5"};